document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('[data-search-overlay]');
  document.querySelectorAll('[data-search-open]').forEach(b => b.addEventListener('click', () => {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('no-scroll');
    setTimeout(() => overlay.querySelector('input')?.focus(), 30);
  }));
  document.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', () => {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove('no-scroll');
  }));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay && !overlay.hidden) {
      overlay.hidden = true; document.body.classList.remove('no-scroll');
    }
  });
});